import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import ArchitectsOfLegalSovereignty from "./sections/ArchitectsOfLegalSovereignty";
import TrustArchitectures from "./sections/TrustArchitectures";
import TheVestaPhilosophy from "./sections/TheVestaPhilosophy";
import TheLegacyRoadmap from "./sections/TheLegacyRoadmap";
import ClientPerspectives from "./sections/ClientPerspectives";
import SecureYourFuture from "./sections/SecureYourFuture";
import FirmInformation from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <ArchitectsOfLegalSovereignty />
      <TrustArchitectures />
      <TheVestaPhilosophy />
      <TheLegacyRoadmap />
      <ClientPerspectives />
      <SecureYourFuture />
      <FirmInformation />
    </div>;
}